import React, { useState } from 'react';
import { Form, Input, Modal } from 'antd';
import { modifyPassword } from '@/services';
import { message } from '@/utils';
import { finalize } from 'rxjs';

interface ModifyPasswordProps {
  open?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
}

const ModifyPassword = (props: ModifyPasswordProps) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [form] = Form.useForm();

  const close = () => {
    props.onOpenChange?.call(null, false);
  };

  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    close();
    form.resetFields();
  };

  const onFinish = (values: any) => {
    const { confirm, ...data } = values;
    setConfirmLoading(true);
    modifyPassword(data).pipe(finalize(() => {
      setConfirmLoading(false);
    })).subscribe({
      next() {
        void message.success('密码修改成功');
        close();
        form.resetFields();
      },
    });
  };

  return (
    <Modal
      title="修改密码"
      open={props.open}
      onOk={handleOk}
      confirmLoading={confirmLoading}
      destroyOnClose={true}
      maskClosable={false}
      keyboard={false}
      onCancel={handleCancel}>

      <Form
        name="basic"
        form={form}
        labelCol={{ span: 7 }}
        style={{ maxWidth: 600 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label="旧密码"
          name="oldPassword"
          rules={[{ required: true, message: '请输入旧密码' }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label="新密码"
          name="newPassword"
          hasFeedback
          rules={[{ required: true, message: '请输入新密码' }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label="再次输入新密码"
          name="confirm"
          hasFeedback
          rules={[
            {
              required: true,
              message: '请再次输入新密码',
            },
            ({ getFieldValue }) => ({
              async validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('两次密码不一致'));
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>

      </Form>
    </Modal>
  );
};

export default ModifyPassword;
